// @core/api/endpoints/project/archive_project.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ArchiveProjectRequest,
  ProjectResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Archive project
 * Archives the project, hiding it from active views while preserving all data. Archived projects can be restored.
 */
export async function ArchiveProject(
  project_id: string,
  data: ArchiveProjectRequest,
  options?: RequestOptions
): Promise<ProjectResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/archive`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<ProjectResponse>(requestPath, data, requestOptions);
}
